
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import { Elements } from "../../../../shared/Elements";
import { Siren } from "../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import { ConsusService, HostService, IHost, IMember, IUploadedFile, SanitizedResponse } from "../../../../../services";
import { Button, ButtonManageRef, DateTimeInput, DOMHelper, Dropdown, FormControl, NoseurObject, TextAreaInput, TextInput, useScreenDimension } from "@rivtn/noseur";
import MediaInput, { MediaInputManageRef } from "../../../../shared/MediaInput";
import { usePlan } from "@syllektis/oya-gbewa-react";

export interface BasicProps {
    host: IHost;
    profile: IMember;
}

function Basic(props: BasicProps) {

    let { host } = props;
    const { width } = useScreenDimension();
    const hostService = HostService.getInstance();
    const consusService = ConsusService.getInstance();
    const [profile, _] = React.useState<IMember>(props.profile);
    const labels = i18nManager.Labels.host.settings.general.basic;
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const mediaInputManageRef = React.useRef<MediaInputManageRef>(null);
    const { toggleHostWebsiteVisibility } = usePlan({ toggleHostWebsiteVisibility: false });
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);

    return (<div style={{ marginTop: 10, display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexDirection: (width > 800 ? "row" : "column"), alignItems: "flex-end" }}>
            <MediaInput manageRef={mediaInputManageRef} style={{ alignSelf: "center", marginBottom: 0 }} width={190} height={190}
                default={host?.logo_url} noFillTemplate onGenerateWithAi={async () => {
                    return new File(["We are here"], "we.txt", { type: 'text/plain' });
                }} onSelectFiles={(files) => {
                    consusService.uploadFile("/omnehost/host/", `logo_${host?.external_id}`, files[0]).then(({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                        updateHost({ ...host, logo_url: sanitized.consus_download_url });
                    }).catch(({ errorMessage }: SanitizedResponse<any>) => {
                        setErrorMessage(errorMessage);
                    });
                }} />
            <div style={{ flex: 1, marginLeft: (width > 800 ? 20 : 0), width: "100%" }}>
                <div style={{ display: "flex", flexDirection: (width > 800 ? "row" : "column") }}>
                    <FormControl scheme={Schemes.OMNEHOST} isFieldset fill label={labels.host_id} style={{ marginTop: 15 }}
                        rightContent={<i className="fa fa-copy" style={{ cursor: "pointer" }} onClick={() => DOMHelper.copyToClipboard(host.public_id, () => {
                            Siren.alert(i18nManager.Labels.common.copied, { lifetime: 1000 });
                        })} />}>
                        <TextInput fill disabled defaultValue={host.public_id} />
                    </FormControl>
                    <FormControl scheme={Schemes.OMNEHOST} isFieldset fill label={labels.name} style={{ marginTop: 15, marginLeft: (width > 800 ? 20 : 0) }}>
                        <TextInput defaultValue={host.name} fill onInputComplete={(value: string) => {
                            host.name = value;
                        }} />
                    </FormControl>
                </div>
                <div style={{ display: "flex", flexDirection: (width > 800 ? "row" : "column") }}>
                    <FormControl scheme={Schemes.OMNEHOST} isFieldset fill label={labels.email_addr} style={{ marginTop: 15 }}>
                        <TextInput defaultValue={host.email_address} fill onInputComplete={(value: string) => {
                            host.email_address = value;
                        }} />
                    </FormControl>
                    <FormControl scheme={Schemes.OMNEHOST} isFieldset fill label={labels.homepage} style={{ marginTop: 15, marginLeft: (width > 800 ? 20 : 0) }}>
                        <TextInput defaultValue={host.homepage} fill onInputComplete={(value: string) => {
                            host.homepage = value;
                        }} />
                    </FormControl>
                </div>
                <div style={{ display: "flex", flexDirection: (width > 800 ? "row" : "column") }}>
                    <FormControl scheme={Schemes.OMNEHOST} isFieldset fill label={labels.base_country} style={{ marginTop: 15 }}>
                        <Dropdown fill options={i18nManager.CountriesAndCurrencies} optionMap={{ label: "label", value: "value" }}
                            selectedOptionIndex={i18nManager.CountriesAndCurrencies?.findIndex(c => c.value === host.country_code)}
                            onSelectOption={(country) => {
                                host.country_code = country.value;
                            }} />
                    </FormControl>
                    <Dropdown fill selectedOptionIndex={i18nManager.Labels.account.profile_website.general.basic.visibility.options?.findIndex((o) => o.value === host.visibility)}
                        disabled={!toggleHostWebsiteVisibility} scheme={Schemes.OMNEHOST} style={{ width: "100%" }} formControlProps={{
                            fill: true,
                            isFieldset: true,
                            label: labels.visibility,
                            style: { marginTop: 8, marginLeft: (width > 800 ? 10 : 0) },
                        }} options={i18nManager.Labels.account.profile_website.general.basic.visibility.options}
                        onSelectOption={(o) => {
                            host.country_code = o.value;
                        }} />
                </div>
            </div>
        </div>
        <div style={{ display: "flex" }}>
            <div style={{ marginTop: 15, flex: 1 }}>
                <FormControl scheme={Schemes.OMNEHOST} isFieldset fill label={labels.short_info}>
                    <TextAreaInput defaultValue={host.short_info} style={{ height: 200 }} fill onInputComplete={(value: string) => {
                        host.short_info = value;
                    }} />
                </FormControl>
                <div style={{ color: "#FF7171", marginTop: 20, display: "none" }}>{labels.short_info_desc}</div>
            </div>
            <div className="host-id-sec" style={{ display: "none" }}>
                <div className="header">
                    <div className="head">
                        <span>Nigeria</span>
                    </div>
                    <div className="head">
                        <span>Ghana</span>
                        <i className="fa fa-times link danger" />
                    </div>
                    <div className="head">
                        <span>India</span>
                        <i className="fa fa-times link danger" />
                    </div>
                    <div className="head">
                        <span>South Africa</span>
                        <i className="fa fa-times link danger" />
                    </div>
                </div>
                <div className="content">
                    <Dropdown fill selectedOptionIndex={labels.means_of_id_ctrl.options?.findIndex((o) => o.value === host.visibility)}
                        style={{ width: "100%" }} formControlProps={{
                            fill: true,
                            isFieldset: true,
                            label: labels.means_of_id,
                            style: { marginTop: 8, marginLeft: 10 },
                        }} options={labels.means_of_id_ctrl.options}
                        onSelectOption={(o) => {

                        }} />
                    <FormControl isFieldset label={labels.id_number} style={{ marginTop: 15, marginLeft: 20, width: "96%" }}>
                        <TextInput fill onInputComplete={(value: string) => {

                        }} />
                    </FormControl>
                    <div style={{ display: "flex", marginTop: 15, marginLeft: 20 }}>
                        <FormControl fill className="date-range-dd" isFieldset scheme={Schemes.OMNEHOST} label={labels.issue_date} rightContent={"fa fa-calendar"}>
                            <DateTimeInput fill formatDate={(date) => Utils.formatToFineDate4(date)} />
                        </FormControl>
                        <FormControl fill className="date-range-dd" isFieldset scheme={Schemes.OMNEHOST} label={labels.expiry_date} rightContent={"fa fa-calendar"} style={{ marginLeft: 20 }}>
                            <DateTimeInput fill formatDate={(date) => Utils.formatToFineDate4(date)} />
                        </FormControl>
                    </div>
                    <MediaInput manageRef={mediaInputManageRef} style={{ alignSelf: "center", marginLeft: 20, marginTop: 15 }} width={"96%"} height={100}
                        noFillTemplate onGenerateWithAi={async () => {
                            return new File(["We are here"], "we.txt", { type: 'text/plain' });
                        }} />
                </div>
            </div>
        </div>
        {errorMessage && (<div className="error">{errorMessage}</div>)}
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
            style={{ marginTop: 30, padding: "10px 25px", alignSelf: "flex-end" }} onClick={(e) => {
                updateHost({ ...host }, e.manageRef);
            }} />
    </div>);

    function updateHost(payload: IHost, manageRef?: ButtonManageRef) {
        setErrorMessage("");
        manageRef?.setLoadingState(true);
        hostService.updateHost(payload.external_id, payload).then(({ sanitized }: SanitizedResponse<IHost>) => {
            host = sanitized;
            Siren.alert(labels.update_success);
        }).catch(({ errorMessage }: SanitizedResponse<any>) => {
            setErrorMessage(errorMessage);
        }).finally(() => {
            manageRef?.setLoadingState(false);
        });
    }

}

export default Basic;
